import PrivateRoutes from 'routes/PrivateRoutes';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const PatientPortal = withLazyFallback(() => import('components/Patient'));
const PatientDashboard = withLazyFallback(
  () => import('components/Patient/Dashboard/PatientDashboard')
);
const PatientMedicalRecords = withLazyFallback(() => import('components/Patient/MedicalRecords'));
const PatientTreatmentPlans = withLazyFallback(
  () => import('components/Patient/TreatmentPlans/PatientTreatmentPlans')
);
const AccountContainer = withLazyFallback(
  () => import('components/Patient/account/indexContainer')
);
const PatientAppointments = withLazyFallback(
  () => import('components/Patient/appointments/PatientDashboardAppointments')
);
const PatientDocumentsForPractice = withLazyFallback(
  () => import('components/Patient/documents/DocumentsForPractice')
);
const PatientDocuments = withLazyFallback(
  () => import('components/Patient/documents/PatientDocuments')
);
const PatientForms = withLazyFallback(() => import('components/Patient/forms/PatientForms'));
const PatientConversation = withLazyFallback(
  () => import('components/Patient/inbox/PatientConversation')
);
const PatientInbox = withLazyFallback(() => import('components/Patient/inbox/inbox'));
const PatientMedications = withLazyFallback(() => import('components/Patient/medications'));
const PatientPayments = withLazyFallback(() => import('components/Patient/billing/payments'));
const PatientQuestionnaires = withLazyFallback(() => import('components/Patient/questionnaires'));
const PatientReferrals = withLazyFallback(() => import('components/Patient/referrals'));
const PatientSuperbills = withLazyFallback(() => import('components/Patient/billing/superbills'));
const Orders = withLazyFallback(() => import('components/practice/PracticeIQueue/Orders/Orders'));
const PatientBilling = withLazyFallback(() => import('components/Patient/billing/PatientBilling'));
const PatientInvoices = withLazyFallback(
  () => import('components/Patient/billing/invoices/PatientInvoices')
);
const PatientQuotes = withLazyFallback(
  () => import('components/Patient/billing/Quotes/PatientQuotes')
);

const PATIENT_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="" />,
    children: [
      {
        path: 'myportal',
        element: <PatientPortal />,
        children: [
          { path: '', element: <PatientDashboard /> },
          { path: 'inbox', element: <PatientInbox /> },
          { path: 'inbox/:myPortalPractice', element: <PatientConversation /> },
          { path: 'medical-records', element: <PatientMedicalRecords /> },
          { path: 'treatment-plans', element: <PatientTreatmentPlans /> },
          { path: 'appointments', element: <PatientAppointments /> },
          {
            path: 'billing',
            element: <PatientBilling />,
            children: [
              { path: '', element: <PatientPayments /> },
              { path: 'invoices', element: <PatientInvoices /> },
              { path: 'superbills', element: <PatientSuperbills /> },
              { path: 'quotes', element: <PatientQuotes /> }
            ]
          },
          { path: 'questionnaires', element: <PatientQuestionnaires /> },
          { path: 'medications', element: <PatientMedications /> },
          { path: 'referrals', element: <PatientReferrals /> },
          { path: 'documents', element: <PatientDocuments /> },
          { path: 'documents/:myPortalPractice', element: <PatientDocumentsForPractice /> },
          { path: 'documents/:myPortalPractice/:pathId', element: <PatientDocumentsForPractice /> },
          { path: 'account', element: <AccountContainer /> },
          { path: 'forms', element: <PatientForms /> },
          { path: 'orders', element: <Orders fromPatient /> },
          { path: '*', element: <NotFound portal="myportal" /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PATIENT_DASHBOARD;
